import React, { useState, useEffect, useRef } from 'react';
import './Memcheck.scss';
import { useHistory,useLocation } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { PRIMARY_LANG, TS_STYLD_COMPS, LANG_STYLD_EXT } from "Common/constant";
import api from "utils/api";
import Bicycle from '../../assets/images/1-bicycle-PEN.jpg';
import Walking from '../../assets/images/3-boy-CAT.jpg';
import Guitar from '../../assets/images/2-guitar-FAN.jpg';
import Emu from '../../assets/images/4-emu-SUN.jpg';
import Crocodile from '../../assets/images/5-crocodile-BALL.jpg';
import Yellowtwo from '../../assets/icons/icon_number_yellow_2.svg';
import Yellowone from '../../assets/icons/icon_number_yellow_1.svg';
import Yellowthree from '../../assets/icons/icon_number_yellow_3.svg';
import DisortedR from '../../assets/images/1-distorted-R.jpg';
import DisortedK from '../../assets/images/2-distorted-K.jpg';
import DisortedM from '../../assets/images/3-distorted-M.jpg';
import DisortedW from '../../assets/images/4-distorted-W.jpg';
import DisortedN from '../../assets/images/5-distorted-N.jpg';
import DisortedE from '../../assets/images/6-distorted-E.jpg';
import DisortedT from '../../assets/images/7-distorted-T.jpg';
import DisortedS from '../../assets/images/8-distorted-S.jpg';
import DisortedA from '../../assets/images/9-distorted-A.jpg';
import Camel from '../../assets/images/Camel.jpg';
import CamelOption1 from '../../assets/images/CamelOption1.jpg';
import CamelOption2 from '../../assets/images/CamelOption2.jpg';
import CamelOption3 from '../../assets/images/CamelOption3.jpg';
import CamelOption4 from '../../assets/images/CamelOption4.jpg';
import Frog from '../../assets/images/Frog.jpg';
import Frogoption1 from '../../assets/images/FrogOption1.jpg';
import Frogoption2 from '../../assets/images/FrogOption2.jpg';
import Frogoption3 from '../../assets/images/FrogOption3.jpg';
import Frogoption4 from '../../assets/images/FrogOption4.jpg';
import Flight from '../../assets/images/Flight.jpg';
import FlightOption1 from '../../assets/images/FlightOption1.jpg';
import FlightOption2 from '../../assets/images/FlightOption2.jpg';
import FlightOption3 from '../../assets/images/FlightOption3.jpg';
import FlightOption4 from '../../assets/images/FlightOption4.jpg';
import Screw from '../../assets/images/Screw.jpg';
import ScrewOption1 from '../../assets/images/ScrewOption1.jpg';
import ScrewOption2 from '../../assets/images/ScrewOption2.jpg';
import ScrewOption3 from '../../assets/images/ScrewOption3.jpg';
import ScrewOption4 from '../../assets/images/ScrewOption4.jpg';
import Candle from '../../assets/images/Candle.jpg';
import CandleOption1 from '../../assets/images/CandleOption1.jpg';
import CandleOption2 from '../../assets/images/CandleOption2.jpg';
import CandleOption3 from '../../assets/images/CandleOption3.jpg';
import CandleOption4 from '../../assets/images/CandleOption4.jpg';
import SecClock from '../../assets/icons/Capa_1.svg'
import MemcheckImg from '../../assets/img/MemcheckBeginImg.svg';
import BackButtonEmptyBackground from "Components/BackButtonEmptyBackground";
import { useSelector } from "react-redux";
import backarrowsmall from  '../../../src/assets/img/back-arrow-small.svg';
import { Button } from "antd";
import { ON_BOARD_PAGES } from "Common/constant";
import { is_web_view } from 'Common/constant';


function CircleTimer({ timeLeft, total = 10 }) {
    const size = 56;
    const radius = 24;
    const circumference = 2 * Math.PI * radius;

    const progress = Math.max(0, Math.min(1, timeLeft / total));
    const offset = circumference * (1 - progress);

    return (
        <div className="circle-timer">
            <svg width={size} height={size}>
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="#D6D6D6"
                    strokeWidth="6"
                    fill="none"
                />
                <circle
                    key={`t-${Math.floor(timeLeft * 10)}`}
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    style={{ stroke: "var(--teal-600)" }}
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    className="timer-progress"
                />
            </svg>
            <img src={SecClock} className="circle-icon" alt="sec" />
        </div>
    );
}




export default function MemCheckApp() {

  const location = useLocation();
    const isGuestUser = location.pathname.includes("guest-user");
const user_details = useSelector((state) => state.loginReducer.user_details);
const history = useHistory()
  const uuid = useSelector(
    (state) => state.assessmentReducer.selectedGuestUUID
  );
    console.log("Guest UUID from redux:", uuid);
    console.log("isGuestUser:", isGuestUser);
  console.log("MemCheckApp isGuestUser:", isGuestUser);
  console.log("User details in MemCheckApp:", user_details)
  const [currentPage, setCurrentPage] = useState(isGuestUser ? 'instr-pwa' : 'welcome');
    const [trailMakingScore, setTrailMakingScore] = useState(0);
    const [alfaScore, setAlfaScore] = useState(0);
    const [ppmScore, setPpmScore] = useState(0);
    const [recallScore, setRecallScore] = useState(0);

    // For debugging you can console.log scores
    // useEffect(() => console.log({ trailMakingScore, alfaScore, ppmScore, recallScore }), [trailMakingScore, alfaScore, ppmScore, recallScore]);

    return (
        <>
                <div 
className={`${
    isGuestUser
      ? "app-container-memcheck-guest-user"
      : "app-container-memcheck"
  }`}                >
                    {renderPage()}
                </div>
        </>
    );

    function renderPage() {
        switch (currentPage) {
            case 'welcome':
                return <WelcomePage onNext={() => setCurrentPage('instr-pwa')} />;
            case 'instr-pwa':
                return <InstructionPWA onNext={() => setCurrentPage('test-pwa')} 
                  onBack={() => {
                    if (isGuestUser) {
                        history.push("/guest-user/begin-assessment");
                    } else {
                        // For logged-in users, go back to welcome page
                        setCurrentPage('welcome');
                    }
                }}  />;
            case 'test-pwa':
                return <TestPWA onNext={() => setCurrentPage('instr-tmt')} />;
            case 'instr-tmt':
                return <InstructionTMT onNext={() => setCurrentPage('test-tmt')} />;
            case 'test-tmt':
                return <TestTMT onNext={() => setCurrentPage('instr-alfa')} setTrailMakingScore={setTrailMakingScore} />;
            case 'instr-alfa':
                return <InstructionALFA onNext={() => setCurrentPage('test-alfa')} />;
            case 'test-alfa':
                return <TestALFA onNext={() => setCurrentPage('instr-ppm')} setAlfaScore={setAlfaScore} />;
            case 'instr-ppm':
                return <InstructionPPM onNext={() => setCurrentPage('test-ppm')} />;
            case 'test-ppm':
                return <TestPPM onNext={() => setCurrentPage('instr-pwb')} setPpmScore={setPpmScore} />;
            case 'instr-pwb':
                return <InstructionPWB onNext={() => setCurrentPage('test-pwb')} />;
            case 'test-pwb':
                return <TestPWB
                    onNext={() => setCurrentPage('welcome')}
                    setRecallScore={setRecallScore}
                    // pass all scores & post function to submit at end
                    scores={{ trailMakingScore, alfaScore, ppmScore, recallScore }}
                    isGuestUser={isGuestUser} 
                        uuid={uuid}
                         user_details={user_details}
//                     postResult={async (extraOnSuccess) => {
//                      const payload = {
//     assessment_type: "memcheck",
//     user_type: "adult",
//     is_completed: true,
//     available_condition: "Completed",
//     is_assessment_eligible: false,
//     data: [
//         { question_id: 92, answer_score: trailMakingScore, is_selected: true },
//         { question_id: 93, answer_score: alfaScore, is_selected: true },
//         { question_id: 94, answer_score: ppmScore, is_selected: true },
//         { question_id: 95, answer_score: recallScore, is_selected: true }
//     ]
// };


//                         try {
//                             const res = await postMemcheckResult(payload);
//                             if (typeof extraOnSuccess === "function") extraOnSuccess(res);
//                             return res;
//                         } catch (err) {
//                             throw err;
//                         }
//                     }}
                />;
            default:
                return <WelcomePage onNext={() => setCurrentPage('instr-pwa')} />;
        }
    }
}




// Welcome Page Component 

function WelcomePage({ onNext }) {

    const history = useHistory();

  const location = useLocation();

      const { user_details } = useSelector((state) => state.loginReducer);
      const { org_type, is_profile_completed } =  user_details || {};



  return (
        <>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>


               { (!is_web_view)&&
                <Button
                 className='back-btn-without-background' 

       onClick={() => {
              if (org_type === "corporate" && !is_profile_completed) {
                history.push({
                  pathname: "/logged-in-user/pathway-process",
                  state: {
                    from: "begin-assessment",
                    hasGatePass: true,
                  },
                });
              }

              else if (location.pathname.includes("logged-in-user")) {
                history.push("/logged-in-user/assessment");
              }
            }} 
                       //   label={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.BACK,{lng:tgtLangST})}</Trans>} 
            ><img src={backarrowsmall}></img>Back</Button>
               }
            </div>

            <div className="welcome-root">
                <div className="welcome-content">
                    <img
                        className="welcome-image"
                        src={MemcheckImg}
                        alt="Teamwork illustration"
                    />
                    <div className="welcome-text">
                        <h1 className="title">MemCheck</h1>
                        <p className="subtitle">
                            An assessment that detects subtle shifts in memory and thinking, helping determine whether dementia screening is recommended.
                        </p>
                        <div className="info-box">
                            <p>It should take less than 2 minutes to complete.</p>
                        </div>
                        <button className="btn-primary" onClick={onNext}>
                            Begin
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

// Instruction Components (unchanged except small cosmetic)

function InstructionPWA({ onNext, onBack }) {

     const history = useHistory();
    const location = useLocation();
    const isGuestUser = location.pathname.includes("guest-user");
    
    return (
        <>
    {!is_web_view && (
            <div className='eferf_ekfbackkk'>
                <Button
                    className='back-btn-without-background'
                    onClick={onBack}
                >
                    <img src={backarrowsmall} alt="back" />Back
                </Button>
            </div>
        )}
        <div className="instr-wrap">
            <div className="instr-progress">
                <div className="instr-step active">1</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">2</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">3</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">4</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">5</div>
            </div>
            <div className="instr-title">Picture – Word Memory Test</div>
            <p className="instr-subtitle">Please read the instructions before each test carefully and then begin the test.</p>
            <div className="instr-cards">
                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowone} alt="check" />
                    </div>
                    <div className="instr-text">
                        You will now be shown a series of 5 word-picture pairs, <strong>TWICE</strong>.
                    </div>
                </div>
                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowtwo} alt="check" />
                    </div>
                    <div className="instr-text">
                        Please <strong>remember the word-picture combination.</strong> You will be asked to recall them later.
                    </div>
                </div>
            </div>
            <button className="instr-btn" onClick={onNext}>
                Start
            </button>
        </div>
        </>
    );
}

// TestPWA (unchanged logic) — it doesn't provide a score by itself here

function TestPWA({ onNext }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [cycle, setCycle] = useState(1);
    const [timeLeft, setTimeLeft] = useState(5);
    const [isTaskTimeUp, setIsTaskTimeUp] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const indexRef = useRef(0);
    const cycleRef = useRef(1);
    const rafRef = useRef(null);

    const studyItems = [
        { image: Bicycle, word: "PEN" },
        { image: Walking, word: "CAT" },
        { image: Guitar, word: "FAN" },
        { image: Emu, word: "SUN" },
        { image: Crocodile, word: "BALL" }
    ];

    useEffect(() => {
        if (isLoading || isTaskTimeUp) return;

        let start = performance.now();

        const tick = (now) => {
            const elapsed = (now - start) / 1000;
            const remaining = 5 - elapsed;
            setTimeLeft(Math.max(remaining, 0));

            if (remaining <= 0) {
                const nextIndex = indexRef.current + 1;

                if (nextIndex < studyItems.length) {
                    // Move to next item in same cycle
                    indexRef.current = nextIndex;
                    setCurrentIndex(nextIndex);
                    start = now;
                    setTimeLeft(5);
                    rafRef.current = requestAnimationFrame(tick);
                } else if (cycleRef.current === 1) {
                    // Start cycle 2
                    cycleRef.current = 2;
                    setCycle(2);
                    indexRef.current = 0;
                    setCurrentIndex(0);
                    start = now;
                    setTimeLeft(5);
                    rafRef.current = requestAnimationFrame(tick);
                } else {
                    // Both cycles done
                    setIsTaskTimeUp(true);
                }
                return;
            }

            rafRef.current = requestAnimationFrame(tick);
        };

        rafRef.current = requestAnimationFrame(tick);
        return () => {
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
        };
    }, [isLoading, isTaskTimeUp]);

    useEffect(() => {
        setIsLoading(true);
        const img = new Image();
        img.src = studyItems[currentIndex].image;
        img.onload = () => setIsLoading(false);
        img.onerror = () => setIsLoading(false);
    }, [currentIndex]);


    return (
        <div className="assessment-wrap">
            <div className="assessment-header">
                <div className="assessment-header-left">
                    <div className="assessment-title">Picture – Word Memory Test</div>
                    <div className="assessment-question"><span className='question-cycle01'>REPETITION {cycle}</span><span>  • </span> <span className='question-Combin01'> COMBINATION {currentIndex + 1}</span></div>
                </div>
                <div className="assessment-header-right">
                    {!isTaskTimeUp ? (
                        <CircleTimer timeLeft={timeLeft} total={5} />
                    ) : <></>}
                </div>
            </div>

            <div className="pwa-content">
                {!isTaskTimeUp ? (
                    <>
                        <div className="pwa-image-box">
                            {isLoading ? (
                                <div className="pwa-image-loader"></div>
                            ) : (
                                <img
                                    key={currentIndex}
                                    src={studyItems[currentIndex].image}
                                    alt="study item"
                                    className="pwa-img"
                                />
                            )}
                        </div>

                        <div className="pwa-word-box">
                            {!isLoading && (
                                <div className="pwa-word" key={currentIndex + "-word"}>
                                    {studyItems[currentIndex].word}
                                </div>
                            )}
                        </div>

                    </>
                ) : (
                    <div className='pwa-else-content'>
                        <div className='pwa-else-content-inside'>
                            <div className='title-content-inside'>Series Completed!</div>
                            <button
                                className="next-btn-new32"
                                style={{ margin: '0 auto' }}
                                onClick={onNext}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// TestTMT (Trail Making) — we call setTrailMakingScore when test finishes

function TestTMT({ onNext, setTrailMakingScore }) {
    const [nodes, setNodes] = useState([]);
    const [expected, setExpected] = useState({ type: 'num', val: 1 });
    const [pairs, setPairs] = useState(0);
    const [timeLeft, setTimeLeft] = useState(120);
    const [completed, setCompleted] = useState([]);
    const [isTimeUp, setIsTimeUp] = useState(false);
    const boardRef = useRef(null);

    useEffect(() => {
        const generateRandomSpreadNodes = () => {
            const board = boardRef.current;
            if (!board) return;

            const rect = board.getBoundingClientRect();
            const width = rect.width;
            const height = rect.height;

            // Responsive node size based on screen width
            const screenWidth = window.innerWidth;
            const nodeSize = screenWidth < 500 ? 45 : 48;
            const margin = nodeSize / 2 + 8;

            // Responsive grid based on screen size
            const cols = screenWidth < 500 ? 4 : 6;
            const rows = screenWidth < 500 ? 5 : 4;
            const totalSlots = cols * rows; // needs to be >= 20 (2 * 10)
            if (totalSlots < 20) {
                // make sure grid big enough
                console.warn('Increase grid size: cols*rows should be >= 20');
            }

            const zoneW = width / cols;
            const zoneH = height / rows;

            // generate zone centers
            const zones = [];
            for (let r = 0; r < rows; r++) {
                for (let c = 0; c < cols; c++) {
                    const cx = c * zoneW + zoneW / 2;
                    const cy = r * zoneH + zoneH / 2;
                    zones.push({ idx: zones.length, cx, cy, col: c, row: r });
                }
            }

            // helper utilities
            const dist = (a, b) => Math.hypot(a.cx - b.cx, a.cy - b.cy);

            // min distance between pair zones: at least 1 zone apart (tunable)
            const minZoneDistance = Math.max(zoneW, zoneH) * (screenWidth < 500 ? 1.5 : 1.2); // ensures pair not adjacent, more spread on small screens

            // We'll attempt to build assignments multiple times if constraints can't be met
            const maxTries = 40;
            let tryCount = 0;
            let finalNodes = null;

            while (tryCount < maxTries && finalNodes === null) {
                tryCount++;

                // make a mutable copy of zones and shuffle it
                const available = zones.slice();
                for (let i = available.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [available[i], available[j]] = [available[j], available[i]];
                }

                const nodesArr = [];
                let success = true;

                // to place 10 pairs, pick slots for each pair ensuring pair zone distance constraint
                for (let pair = 1; pair <= 10; pair++) {
                    if (available.length === 0) {
                        success = false;
                        break;
                    }

                    // pick a random index from available for the number
                    const numIdx = Math.floor(Math.random() * available.length);
                    const numZone = available.splice(numIdx, 1)[0];

                    // for the dot, we need a zone from available that is >= minZoneDistance away from numZone
                    // find all candidate indices
                    const candidateIndices = [];
                    for (let k = 0; k < available.length; k++) {
                        if (dist(numZone, available[k]) >= minZoneDistance) {
                            candidateIndices.push(k);
                        }
                    }

                    // If no candidate found, we can try to select a dot zone that is not the immediate neighbor by checking
                    // a slightly relaxed threshold, or abandon this try and reshuffle
                    if (candidateIndices.length === 0) {
                        // Option: try relaxed threshold (smaller), but to guarantee separation we abandon this attempt
                        success = false;
                        break;
                    }

                    // pick random candidate index for dot
                    const chosenCandidateIdx = candidateIndices[Math.floor(Math.random() * candidateIndices.length)];
                    const dotZone = available.splice(chosenCandidateIdx, 1)[0];

                    // apply small random jitter inside zone but keep inside margin
                    const jitter = (max) => (Math.random() * 2 - 1) * max;
                    const jitterMaxX = screenWidth < 500 ? Math.max(5, zoneW / 6) : Math.max(10, zoneW / 5);
                    const jitterMaxY = screenWidth < 500 ? Math.max(5, zoneH / 6) : Math.max(10, zoneH / 5);

                    const numX = Math.min(Math.max(numZone.cx + jitter(jitterMaxX), margin), width - margin);
                    const numY = Math.min(Math.max(numZone.cy + jitter(jitterMaxY), margin), height - margin);

                    const dotX = Math.min(Math.max(dotZone.cx + jitter(jitterMaxX), margin), width - margin);
                    const dotY = Math.min(Math.max(dotZone.cy + jitter(jitterMaxY), margin), height - margin);

                    nodesArr.push({ type: 'num', val: pair, x: numX, y: numY });
                    nodesArr.push({ type: 'dot', val: pair, x: dotX, y: dotY });
                } // end for pairs

                if (success && nodesArr.length === 20) {
                    finalNodes = nodesArr;
                    break;
                }
                // else retry (reshuffle) and try again
            } // end while tries

            if (!finalNodes) {
                // As a fallback, fall back to simpler spacing routine (guarantees non-overlap)
                console.warn('Could not meet pair-distance constraints after tries; falling back to safe grid placement.');
                const fallback = [];
                const used = zones.slice(0, 20);
                for (let i = 0; i < 20; i++) {
                    const z = used[i];
                    const jitterMaxX = screenWidth < 500 ? Math.max(5, zoneW / 6) : Math.max(10, zoneW / 5);
                    const jitterMaxY = screenWidth < 500 ? Math.max(5, zoneH / 6) : Math.max(10, zoneH / 5);
                    fallback.push({
                        type: i % 2 === 0 ? 'num' : 'dot',
                        val: Math.floor(i / 2) + 1,
                        x: Math.min(Math.max(z.cx + (Math.random() * 40 - 20), margin), width - margin),
                        y: Math.min(Math.max(z.cy + (Math.random() * 40 - 20), margin), height - margin)
                    });
                }
                setNodes(fallback);
            } else {
                // shuffle finalNodes order so mapping to array indices is random
                for (let i = finalNodes.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [finalNodes[i], finalNodes[j]] = [finalNodes[j], finalNodes[i]];
                }
                setNodes(finalNodes);
            }
        }; // end generateRandomSpreadNodes

        // give browser one tick so board can layout (optional but safer)
        const t = setTimeout(generateRandomSpreadNodes, 30);
        return () => clearTimeout(t);
    }, []);

    useEffect(() => {
        if (timeLeft <= 0 || pairs >= 10) {
            setIsTimeUp(true);
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    setIsTimeUp(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft, pairs]);

    useEffect(() => {
        // Whenever test finishes (time up or all pairs), persist the score to parent
        if (isTimeUp || pairs >= 10) {
            setTrailMakingScore(pairs); // TMT score = pairs completed (count only)
        }
    }, [isTimeUp, pairs, setTrailMakingScore]);

    const [selectedNum, setSelectedNum] = useState(null);

    const handleNodeClick = (node, index) => {
        if (pairs >= 10 || isTimeUp) return;

        if (node.type === 'num' && expected.type === 'num' && node.val === expected.val) {
            setExpected({ type: 'dot', val: node.val });
            setSelectedNum(index);
            // don't mark completed yet
        } else if (node.type === 'dot' && expected.type === 'dot' && node.val === expected.val) {
            const newPairs = pairs + 1;
            setPairs(newPairs);

            const numIndex = nodes.findIndex(n => n.type === 'num' && n.val === node.val);
            setCompleted(prev => [...prev, index, numIndex]);
            setSelectedNum(null);

            if (newPairs < 10) {
                setExpected({ type: 'num', val: node.val + 1 });
            }
        }
    };

    return (
        <div className="assessment-wrap">
            <div className="assessment-header assessment-header-trail">
                <div className="assessment-header-left">
                    <div className="assessment-title">Trail Making Test</div>
                    <div className="assessment-question">MATCHED PAIRS: {pairs}/10</div>
                </div>
                <div className="assessment-header-right">
                    {!isTimeUp ? (
                        <CircleTimer timeLeft={timeLeft} total={120} />
                    ) : <></>}
                </div>
            </div>

            {!isTimeUp ? (
                <div className="tmt-board-shell">
                    <div className="tmt-board" ref={boardRef}>
                        {nodes.map((node, idx) => (
                            <button
                                key={idx}
                                className={`tmt-node ${node.type} ${completed.includes(idx) ? 'armed' : ''} ${selectedNum === idx ? 'selected' : ''}`}
                                style={{
                                    left: `${node.x}px`,
                                    top: `${node.y}px`,
                                    display: completed.includes(idx) ? 'none' : 'flex'
                                }}
                                onClick={() => handleNodeClick(node, idx)}
                            >
                                {node.type === 'num' ? (
                                    <span>{node.val}</span>
                                ) : (
                                    <DotGrid count={node.val} />
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            ) : (
                <div className='pwa-else-content pwa-else-content-trail'>
                    <div className='pwa-else-content-inside'>
                        <div className='title-content-inside'>Pairing Completed!</div>
                        <button
                            className="next-btn-new32"
                            style={{ margin: '0 auto' }}
                            onClick={onNext}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

function DotGrid({ count }) {
    return (
        <div className="dot-grid">
            {Array.from({ length: 10 }).map((_, i) => (
                <span
                    key={i}
                    className="dot"
                    style={{
                        background: i < count ? '#111827' : '#e5e7eb'
                    }}
                />
            ))}
        </div>
    );
}

// TestALFA — count correct letter clicks only

function TestALFA({ onNext, setAlfaScore }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [timeLeft, setTimeLeft] = useState(10);
    const [isLetterTimeUp, setIsLetterTimeUp] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const keyboard = "WERTYUIOPASDFGHJKLZXCVBNM".split("");

    const questions = [
        { image: DisortedR, answer: "R" },
        { image: DisortedK, answer: "K" },
        { image: DisortedM, answer: "M" },
        { image: DisortedW, answer: "W" },
        { image: DisortedN, answer: "N" },
        { image: DisortedE, answer: "E" },
        { image: DisortedT, answer: "T" },
        { image: DisortedS, answer: "S" },
        { image: DisortedA, answer: "A" },
    ];

    const [localAlfaScore, setLocalAlfaScore] = useState(0);

    useEffect(() => {
        if (isLoading || isLetterTimeUp) return; 

        let timeRemaining = 10;
        setTimeLeft(10);

        const timer = setInterval(() => {
            timeRemaining -= 0.1;
            setTimeLeft(Math.max(timeRemaining, 0));

            if (timeRemaining <= 0) {
                clearInterval(timer);
                if (currentIndex < questions.length - 1) {
                    setCurrentIndex(prev => prev + 1);
                } else {
                    setIsLetterTimeUp(true);
                    setAlfaScore(localAlfaScore);
                }
            }
        }, 100);

        return () => clearInterval(timer);
    }, [currentIndex, isLetterTimeUp, localAlfaScore, setAlfaScore, questions.length, isLoading]); 

    useEffect(() => {
        setIsLoading(true);
        
        const img = new Image();
        img.src = questions[currentIndex].image;
        
        img.onload = () => {
            setIsLoading(false);
        };
        
        img.onerror = () => {
            setIsLoading(false);
        };
    }, [currentIndex]);

    const handleKeyClick = (key) => {
        if (isLoading) return; // ADDED: Prevent clicking while loading
        
        const currentQuestion = questions[currentIndex];
        if (key === currentQuestion.answer) {
            setLocalAlfaScore(prev => prev + 1);
        }

        if (currentIndex < questions.length - 1) {
            setCurrentIndex(prev => prev + 1);
        } else {
            setIsLetterTimeUp(true);
            setAlfaScore(localAlfaScore + (key === currentQuestion.answer ? 1 : 0));
        }
    };

    const currentQuestion = questions[currentIndex];

    return (
        <div className="assessment-wrap">
            <div className="assessment-header">
                <div className="assessment-header-left">
                    <div className="assessment-title">Incomplete Letters Identification</div>
                    <div className="assessment-question">QUESTION: {currentIndex + 1}/{questions.length}</div>
                </div>
                <div className="assessment-header-right">
                    {!isLetterTimeUp && (
                        <CircleTimer timeLeft={timeLeft} total={10} />
                    )}
                </div>
            </div>
            {!isLetterTimeUp && currentQuestion ? (
                <div className="alfa-content">
                    <div className="alfa-image-box">
                        <img key={currentIndex} src={currentQuestion.image} alt="letter mask" />
                    </div>
                    <div className="alfa-keys">
                        {keyboard.map(key => (
                            <button key={key} className="alfa-key" onClick={() => handleKeyClick(key)} disabled={isLoading}>
                                {key}
                            </button>
                        ))}
                    </div>
                </div>
            ) : (
                <div className='pwa-else-content'>
                    <div className='pwa-else-content-inside'>
                        <div className='title-content-inside'>Identification Completed!</div>
                        <button
                            className="next-btn-new32"
                            style={{ margin: '0 auto' }}
                            onClick={onNext}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

// TestPPM — Picture-Picture Matching

function TestPPM({ onNext, setPpmScore }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [timeLeft, setTimeLeft] = useState(10);
    const [isPicTimeUp, setIsPicTimeUp] = useState(false);
    const [localPpmScore, setLocalPpmScore] = useState(0);
    const [isLoading, setIsLoading] = useState(true);


    const questions = [
        {
            top: Camel,
            choices: [CamelOption1, CamelOption2, CamelOption3, CamelOption4],
            correctChoiceIndex: 2
        },
        {
            top: Candle,
            choices: [CandleOption1, CandleOption2, CandleOption3, CandleOption4],
            correctChoiceIndex: 2
        },
        {
            top: Frog,
            choices: [Frogoption1, Frogoption2, Frogoption3, Frogoption4],
            correctChoiceIndex: 1
        },
        {
            top: Flight,
            choices: [FlightOption1, FlightOption2, FlightOption3, FlightOption4],
            correctChoiceIndex: 1
        },
        {
            top: Screw,
            choices: [ScrewOption1, ScrewOption2, ScrewOption3, ScrewOption4],
            correctChoiceIndex: 0
        }
    ];

    useEffect(() => {
        if (isLoading || isPicTimeUp) return;

        let timeRemaining = 10;
        setTimeLeft(10);

        const timer = setInterval(() => {
            timeRemaining -= 0.1;
            setTimeLeft(Math.max(timeRemaining, 0));

            if (timeRemaining <= 0) {
                clearInterval(timer);
                if (currentIndex < questions.length - 1) {
                    setCurrentIndex(prev => prev + 1);
                } else {
                    setIsPicTimeUp(true);
                    setPpmScore(localPpmScore);
                }
            }
        }, 100);

        return () => clearInterval(timer);
    }, [currentIndex, isPicTimeUp, localPpmScore, setPpmScore, questions.length, isLoading]);

    const handleChoice = (choiceIdx) => {
         if (isLoading) return;
        const q = questions[currentIndex];
        if (choiceIdx === q.correctChoiceIndex) {
            setLocalPpmScore(prev => prev + 1);
        }

        if (currentIndex < questions.length - 1) {
            setCurrentIndex(prev => prev + 1);
        } else {
            setIsPicTimeUp(true);
            setPpmScore(localPpmScore + (choiceIdx === q.correctChoiceIndex ? 1 : 0));
        }
    };

    const safeIndex = Math.min(currentIndex, questions.length - 1);
    const q = questions[safeIndex];

    useEffect(() => {
        setIsLoading(true);

        const q = questions[currentIndex];

        // Load top image
        const topImg = new Image();
        topImg.src = q.top;

        const choiceImgs = q.choices.map(src => {
            const img = new Image();
            img.src = src;
            return img;
        });

        let loadedCount = 0;
        const totalImages = 1 + choiceImgs.length;

        const handleLoad = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
                setIsLoading(false);
            }
        };

      topImg.onload = handleLoad;
        topImg.onerror = handleLoad;
        choiceImgs.forEach(img => {
            img.onload = handleLoad;
            img.onerror = handleLoad; 
        });
    }, [currentIndex]);


    return (
        <div className="assessment-wrap">
            <div className="assessment-header">
                <div className="assessment-header-left">
                    <div className="assessment-title">Picture – Picture Matching</div>
                    <div className="assessment-question">
                        QUESTION: {safeIndex + 1}/{questions.length}
                    </div>
                </div>
                <div className="assessment-header-right">
                    {!isPicTimeUp && <CircleTimer timeLeft={timeLeft} total={10} />}
                </div>
            </div>

            {!isPicTimeUp ? (
                <>
                    <div className="ppm-card">
                        <div className="ppm-top">
                            {isLoading ? (
                                <div className="pwa-image-loader"></div>
                            ) : (
                                <img key={currentIndex} src={q.top} alt="target" />
                            )}
                        </div>
                    </div>

                    <div className="ppm-choices">
                        {q.choices.map((choice, idx) => (
                            <button key={idx} className="ppm-choice" onClick={() => handleChoice(idx)}  disabled={isLoading}>
                                {!isLoading && (
                                    <img key={currentIndex} src={choice} alt={`choice ${idx + 1}`} />
                                )}
                            </button>
                        ))}
                    </div>
                </>
            ) : (
                <div className='pwa-else-content'>
                    <div className='pwa-else-content-inside'>
                        <div className='title-content-inside'>Matching Completed!</div>
                        <button
                            className="next-btn-new32"
                            style={{ margin: '0 auto' }}
                            onClick={onNext}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

// TestPWB — Word Recall: submit final payload here

function TestPWB({  setRecallScore, scores,uuid, user_details  }) {
        const history = useHistory();
          const location = useLocation();
  const isGuestUser = location.pathname.includes("guest-user");

    const [currentIndex, setCurrentIndex] = useState(0);
    // const [timeLeft, setTimeLeft] = useState(10);
    const [isRecallTimeUp, setIsRecallTimeUp] = useState(false);
    const [localRecallScore, setLocalRecallScore] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const questions = [
        { image: Bicycle, options: ["PENCIL", "PEN", "ERASER"], correct: "PEN" },
        { image: Walking, options: ["DOG", "CAT", "RAT"], correct: "CAT" },
        { image: Guitar, options: ["FAN", "BULB", "SWITCH"], correct: "FAN" },
        { image: Emu, options: ["MOON", "STAR", "SUN"], correct: "SUN" },
        { image: Crocodile, options: ["BALL", "HELMET", "BAT"], correct: "BALL" }
    ];

    // useEffect(() => {
    //     if (isRecallTimeUp) return;

    //     let timeRemaining = 10;
    //     setTimeLeft(10);

    //     const timer = setInterval(() => {
    //         timeRemaining -= 0.1;
    //         setTimeLeft(Math.max(timeRemaining, 0));

    //         if (timeRemaining <= 0) {
    //             clearInterval(timer);
    //             if (currentIndex < questions.length - 1) {
    //                 setCurrentIndex(prev => prev + 1);
    //             } else {
    //                 setIsRecallTimeUp(true);
    //                 setRecallScore(localRecallScore);
    //             }
    //         }
    //     }, 100);

    //     return () => clearInterval(timer);
    // }, [currentIndex, isRecallTimeUp, localRecallScore, setRecallScore]);

    const handleChoice = (choice) => {
        if (isLoading) return;
        const q = questions[currentIndex];
        if (choice === q.correct) {
            setLocalRecallScore(prev => prev + 1);
        }

        if (currentIndex < questions.length - 1) {
            setCurrentIndex(prev => prev + 1);
        } else {
            setIsRecallTimeUp(true);
            setRecallScore(localRecallScore + (choice === q.correct ? 1 : 0));
        }
    };

const handleSubmit = async () => {
    try {
        // Ensure the recall score is set with the latest value
        const finalRecallScore = localRecallScore;
        setRecallScore(finalRecallScore);

        // Prepare the assessment data
        const assessmentData = [
            { question_id: 92, answer_score: scores.trailMakingScore, is_selected: true },
            { question_id: 93, answer_score: scores.alfaScore, is_selected: true },
            { question_id: 94, answer_score: scores.ppmScore, is_selected: true },
            { question_id: 95, answer_score: finalRecallScore, is_selected: true }
        ];

        console.log("Submitting assessment data:", assessmentData);
        console.log("User details:", user_details);

        // Handle mobile app submission
        if (window.Android) {
            const mobilePayload = {
                assessment_type: "memcheck",
                user_type: "adult",
                is_completed: true,
                available_condition: "Completed",
                is_assessment_eligible: false,
                ...(isGuestUser && uuid ? { uuid } : {}),
                data: assessmentData
            };
            window.Android.onApiResponse(JSON.stringify(mobilePayload));
            return;
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onApiResponse) {
            const mobilePayload = {
                assessment_type: "memcheck",
                user_type: "adult",
                is_completed: true,
                available_condition: "Completed",
                is_assessment_eligible: false,
                ...(isGuestUser && uuid ? { uuid } : {}),
                data: assessmentData
            };
            window.webkit.messageHandlers.onApiResponse.postMessage(JSON.stringify(mobilePayload));
            return;
        }

        let response;
        
        // Check if B2B corporate user without completed profile
        const isB2BFlow = user_details?.org_type === "corporate" && !user_details?.is_profile_completed;
        
        console.log("Is B2B Flow:", isB2BFlow);

        if (isB2BFlow) {
            // B2B: Use pathway track API
            console.log("Using pathway track API for B2B");
            
            const pathwayPayload = {
                page: ON_BOARD_PAGES.assessment,
                is_completed: true,
                is_skipped: false,
                self_assessment: {
                    user_type: user_details?.user_type || "adult",
                    assessment_type: "memcheck",
                    data: assessmentData
                }
            };
            
            console.log("Pathway payload:", pathwayPayload);
            response = await api.post_pathway_track(pathwayPayload);
            
        } else {
            // B2C or completed B2B profile: Use regular assessment submit API
            console.log("Using assessment submit API for B2C");
            
            const assessmentPayload = {
                assessment_type: "memcheck",
                user_type: user_details?.user_type || "adult",
                is_completed: true,
                available_condition: "Completed",
                is_assessment_eligible: false,
                ...(isGuestUser && uuid ? { uuid } : {}),
                data: assessmentData
            };
            
            console.log("Assessment payload:", assessmentPayload);
            response = await api.assessment_submit(assessmentPayload);
        }

        console.log("handleSubmit - Full API Response:", response);
        console.log("handleSubmit - Response data:", response.data);

        // Extract score details from response
        const scoreDetails = response.data?.data || response.data;
        
        console.log("Navigating with scoreDetails:", scoreDetails);

        if (isGuestUser) {
            history.replace({
                pathname: "/guest-user/assessment-completion",
                state: {
                    assessmentCompleted: true
                }
            });
        } else {
            const fromValue = isB2BFlow ? "assessment-completion" : "assessment";
            
            history.push({
                pathname: "/logged-in-user/score-details",
                state: {
                    from: fromValue,
                    score_details: scoreDetails,
                    assessmentType: "memcheck"
                }
            });
        }

        console.log("Navigation called successfully");

    } catch (err) {
        console.error("Submission failed - Full error:", err);
        console.error("Error response:", err.response);
        console.error("Error message:", err.message);
        alert("Failed to submit assessment. Please try again.");
    }
};




    const safeIndex = Math.min(currentIndex, questions.length - 1);
    const q = questions[safeIndex];


    useEffect(() => {
        setIsLoading(true);

        const img = new Image();
        img.src = q.image;

        img.onload = () => {
            setIsLoading(false);
        };

            img.onerror = () => {
            setIsLoading(false);
        };
    }, [currentIndex]);



    return (
        <div className="assessment-wrap">
            <div className="assessment-header">
                <div className="assessment-header-left">
                    <div className="assessment-title">Word Recall</div>
                    <div className="assessment-question">
                        COMBINATION: {safeIndex + 1}/{questions.length}
                    </div>
                </div>

                {/* <div className="assessment-header-right">
                    {!isRecallTimeUp && <CircleTimer timeLeft={timeLeft} total={10} />}
                </div> */}
            </div>

            {!isRecallTimeUp ? (
                <>
                    <div className="pwb-image-box">
                        {isLoading ? (
                            <div className="pwa-image-loader"></div>
                        ) : (
                            <img key={currentIndex} src={q.image} alt="prompt" />
                        )}
                    </div>

                    <div className="pwb-options-container">
                        {!isLoading && (
                            <div className="pwb-options">

                                {q.options.map((option, idx) => (
                                    <button key={idx} className="pwb-opt" onClick={() => handleChoice(option)} disabled={isLoading}>
                                        {option}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <div className="pwa-else-content">
                    <div className='pwa-else-content-inside'>
                        <div className='title-content-inside'>Word Recall Completed!</div>
                        <button className="next-btn-new32" onClick={handleSubmit} style={{ margin: "0 auto" }}>
                            Submit
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}


function InstructionTMT({ onNext }) {
    return (
        <div className="instr-wrap">
            <div className="instr-progress">
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step active">2</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">3</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">4</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">5</div>
            </div>

            <div className="instr-title">Trail Making Test</div>
            <p className="instr-subtitle">Please read the instructions before each test carefully and then begin the test.</p>

            <div className="instr-cards">
                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowone} alt="check" />
                    </div>
                    <div className="instr-text">
                        You will now see two sets of circles – one with numbers and the other with dots.
                    </div>
                </div>

                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowtwo} alt="check" />
                    </div>
                    <div className="instr-text">
                        Start by clicking on the circle with <strong> Number 1 and next, click the circle with 1 Dot.</strong> Then click Number 2 and next click the circle with 2 Dots and so on.
                    </div>
                </div>

                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowthree} alt="check" />
                    </div>
                    <div className="instr-text">
                        Continue this pattern: Number → Dots → Number → Dots until you complete all.
                    </div>
                </div>
            </div>

            <button className="instr-btn" onClick={onNext}>
                Start
            </button>
        </div>
    );
}

function InstructionALFA({ onNext }) {
    return (
        <div className="instr-wrap">
            <div className="instr-progress">
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step active">3</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">4</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">5</div>
            </div>

            <div className="instr-title">Incomplete Letters Identification</div>
            <p className="instr-subtitle">Please read the instructions before each test carefully and then begin the test.</p>

            <div className="instr-cards">
                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowone} alt="check" />
                    </div>
                    <div className="instr-text">
                        You will be now shown English alphabets in a distorted form.
                    </div>
                </div>

                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowtwo} alt="check" />
                    </div>
                    <div className="instr-text">
                        You must identify the alphabet and select the same letter from the list of options.
                    </div>
                </div>
            </div>

            <button className="instr-btn" onClick={onNext}>
                Start
            </button>
        </div>
    );
}

function InstructionPPM({ onNext }) {
    return (
        <div className="instr-wrap">
            <div className="instr-progress">
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step active">4</div>
                <div className="instr-line"></div>
                <div className="instr-step inactive">5</div>
            </div>

            <div className="instr-title">Picture – Picture Matching</div>
            <p className="instr-subtitle">Please read the instructions before each test carefully and then begin the test.</p>

            <div className="instr-cards">
                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowone} alt="check" />
                    </div>
                    <div className="instr-text">
                        You will now be shown a series of pictures – each containing one picture at the top and four pictures at the bottom.
                    </div>
                </div>

                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowtwo} alt="check" />
                    </div>
                    <div className="instr-text">
                        From the four pictures at the bottom, select the most relevant match.
                    </div>
                </div>
            </div>

            <button className="instr-btn" onClick={onNext}>
                Start
            </button>
        </div>
    );
}

function InstructionPWB({ onNext }) {
    return (
        <div className="instr-wrap">
            <div className="instr-progress">
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step done">✓</div>
                <div className="instr-line"></div>
                <div className="instr-step active">5</div>
            </div>

            <div className="instr-title">Word Recall</div>
            <p className="instr-subtitle">Please read the instructions before each test carefully and then begin the test.</p>

            <div className="instr-cards">
                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowone} alt="check" />
                    </div>
                    <div className="instr-text">
                        Now, recall the word-picture combinations that were shown at the beginning of the test.
                    </div>
                </div>

                <div className="instr-card">
                    <div className="instr-icon">
                        <img src={Yellowtwo} alt="check" />
                    </div>
                    <div className="instr-text">
                        Select the correct word.
                    </div>
                </div>
            </div>

            <button className="instr-btn" onClick={onNext}>
                Start
            </button>
        </div>
    );
}
